import { UserRegisterRequest } from '@flagsync/skyline';
import { UseMutationOptions, useMutation } from '@tanstack/react-query';

import { sky } from '@/services/api-client';
import { ServiceError } from '@/services/utils/service-error';

/**
 * React-query mutation for register.
 *
 * Next.js server actions are bad in the sense that you can't access the response,
 * so we can't set headers or cookies (JWT session), which the client would then access.
 * So, make the call from client -> server, instead of server -> server.
 */
export const useRegister = (
  options?: UseMutationOptions<void, ServiceError, UserRegisterRequest>,
) => {
  return useMutation<void, ServiceError, UserRegisterRequest>({
    mutationFn: (request) => sky.post<void>('/auth/register', request),
    ...options,
  });
};
